<template>
  <div class="card border-0 shadow-none rounded-1 mb-25">
    <div class="card-body p-xl-40">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">IMAGE</th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                NAME
                <img class="ms-2" src="../../../assets/img/icons/up-down-aroow.svg" alt="Image" />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                CODE
                <img class="ms-2" src="../../../assets/img/icons/up-down-aroow.svg" alt="Image" />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                CATEGORY
                <img class="ms-2" src="../../../assets/img/icons/up-down-aroow.svg" alt="Image" />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                PRICE
                <img class="ms-2" src="../../../assets/img/icons/up-down-aroow.svg" alt="Image" />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                QUANTITY
                <img class="ms-2" src="../../../assets/img/icons/up-down-aroow.svg" alt="Image" />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">ACTION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in products" :key="product.id">
              <td class="shadow-none fw-normal text-black title ps-0">
                <div class="d-flex align-items-center product-item border">
                  <img :src="require('../../../assets/img/products/product-thumb-7.webp')" alt="Image" />
                </div>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">{{ product.name }}</td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">{{ product.barCode }}</td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">{{ product.categoryName }}</td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">{{ product.price }}</td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">{{ product.quantity }}</td>
              <td class="shadow-none lh-1 text-end pe-0">
                <div class="button-group d-flex align-items-center">
                  <router-link :to="{ name: 'ProductDetails', params: { id: product.id } }" title="View" class="me-2">
                    <img src="../../../assets/img/icons/eye.svg" alt="Image" />
                  </router-link>
                  <router-link :to="{ name: 'EditProduct', params: { id: product.id } }" title="Edit" class="me-2">
                    <img src="../../../assets/img/icons/edit.svg" alt="Image" />
                  </router-link>
                  <a class="delete-btn"  href="#" role="button" >
                    <img src="../../../assets/img/icons/close.svg" alt="Image" />
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="row pb-45 align-items-center">
    <div class="col-sm-6">
      <div class="d-flex flex-wrap align-items-center justify-content-center justify-content-sm-start page-unit">
        <span class="fs-13">Showing product per page</span>
        <select v-model="pageSize" @change="changePageSize" class="text-title border-0 fs-14 bg-transparent">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
        </select>
      </div>
    </div>
    <div class="col-sm-6 text-sm-end text-center">
      <ul class="page-nav list-style">
        <li>
          <a @click="previousPage" :disabled="currentPage === 1">
            <img src="../../../assets/img/icons/left-arrow-purple.svg" alt="Image" />
          </a>
        </li>
        <li v-for="page in visiblePages" :key="page">
          <a @click="goToPage(page)" :class="{ active: page === currentPage }">{{ page }}</a>
        </li>
        <li>
          <a @click="nextPage" :disabled="currentPage === totalPages">
            <img src="../../../assets/img/icons/right-arrow-purple.svg" alt="Image" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" src="./ProductsList.ts"></script>
